import { createContext } from "react";

const ContentContext = createContext(null);

export default ContentContext;